<template>
  <div class="user-action-filters pa-3 mb-3">
    <v-layout row wrap align-center>
      <v-flex xs12 md3 class="px-2">
        <v-text-field
          v-model="draft.search"
          append-icon="search"
          label="Buscar"
          single-line
          clearable
          hide-details
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6 md4 class="px-2">
        <v-autocomplete
          v-model="draft.company"
          :items="options.companies"
          item-text="text"
          item-value="value"
          label="Empresa"
          browser-autocomplete="off"
          :menu-props="autocompleteMenuProps"
          clearable
          hide-details
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 md3 class="px-2">
        <v-autocomplete
          v-model="draft.action"
          :items="options.actions"
          item-text="text"
          item-value="value"
          label="Acción"
          browser-autocomplete="off"
          :menu-props="autocompleteMenuProps"
          clearable
          hide-details
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 md2 class="px-2">
        <v-autocomplete
          v-model="draft.status"
          :items="options.statuses"
          item-text="text"
          item-value="value"
          label="Estado"
          browser-autocomplete="off"
          :menu-props="autocompleteMenuProps"
          clearable
          hide-details
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 md2 class="px-2">
        <v-autocomplete
          v-model="draft.role"
          :items="options.roles"
          item-text="text"
          item-value="value"
          label="Rol"
          browser-autocomplete="off"
          :menu-props="autocompleteMenuProps"
          clearable
          hide-details
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 md3 class="px-2">
        <v-menu
          v-model="dateFromMenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="formattedDateFrom"
              label="Alta desde"
              readonly
              clearable
              hide-details
              v-on="on"
              @click:clear="draft.date_from = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="draft.date_from"
            locale="es"
            first-day-of-week="1"
            :reactive="true"
            @input="dateFromMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs12 sm6 md3 class="px-2">
        <v-menu
          v-model="dateToMenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="formattedDateTo"
              label="Alta hasta"
              readonly
              clearable
              hide-details
              v-on="on"
              @click:clear="draft.date_to = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="draft.date_to"
            locale="es"
            first-day-of-week="1"
            :reactive="true"
            @input="dateToMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs12 sm6 md4 class="filter-actions text-xs-right px-2">
        <v-btn flat small color="grey darken-1" :disabled="loading" @click="$emit('reset')">
          <v-icon left small>mdi-filter-remove-outline</v-icon>
          Limpiar filtros
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';

const emptyFilters = {
  search: '',
  company: null,
  action: null,
  status: null,
  role: null,
  date_from: null,
  date_to: null,
};

export default {
  name: 'UserActionFilters',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({
        actions: [],
        companies: [],
        statuses: [],
        roles: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      draft: this.normalizeFilters(this.value),
      dateFromMenu: false,
      dateToMenu: false,
      autocompleteMenuProps: {
        closeOnContentClick: true,
        maxHeight: 360,
      },
    };
  },
  computed: {
    formattedDateFrom() {
      return this.draft.date_from ? moment(this.draft.date_from).format('DD/MM/YYYY') : '';
    },
    formattedDateTo() {
      return this.draft.date_to ? moment(this.draft.date_to).format('DD/MM/YYYY') : '';
    },
  },
  methods: {
    normalizeFilters(filters) {
      return Object.assign({}, emptyFilters, filters || {});
    },
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        const next = this.normalizeFilters(value);
        if (JSON.stringify(next) !== JSON.stringify(this.draft)) {
          this.draft = next;
        }
      },
    },
    draft: {
      deep: true,
      handler(value) {
        this.$emit('input', Object.assign({}, value));
        this.$emit('change', Object.assign({}, value));
      },
    },
    dateFromMenu(value) {
      if (value) this.dateToMenu = false;
    },
    dateToMenu(value) {
      if (value) this.dateFromMenu = false;
    },
  },
};
</script>

<style scoped>
.user-action-filters {
  border: 1px solid #eceff1;
}

.filter-actions {
  padding-top: 18px;
}
</style>
